<template>
  <div>
    <div class="w-full grid grid-cols-4 gap-1">
      <div
        class="item"
      >
        <span class="px-1 rounded bg-secondary">{{ `Lv.${authStore.user.level_info.level}` }}</span>
        <span class="truncate">{{ authStore.user.nickname }}</span>
      </div>
      <div
        class="item"
      >
        <SvgIcon
          name="wallet"
          size="14px"
        />
        <span class="truncate">{{ authStore.walletBalance }}</span>
      </div>
      <RouterLink
        class="item"
        :to="{ name: 'exchanges' }"
      >
        <SvgIcon
          name="point"
          size="14px"
        />
        <span class="truncate">{{ authStore.pointBalance }}</span>
      </RouterLink>
      <RouterLink
        class="item"
        :to="{ name: 'consumables' }"
      >
        <SvgIcon
          name="gold"
          size="14px"
        />
        <span class="truncate">{{ authStore.coinBalance }}</span>
      </RouterLink>
    </div>
  </div>
</template>
<script setup>
import SvgIcon from '@/components/Icons/SvgIcon.vue'
import { useAuthStore } from '@/stores/auth.js'

const authStore = useAuthStore()
</script>
<style scoped>
.item {
  @apply px-2 py-1 flex items-center gap-2
}
</style>
